import { render, staticRenderFns } from "./related-info.vue?vue&type=template&id=22bf61f0&scoped=true"
import script from "./related-info.vue?vue&type=script&lang=js"
export * from "./related-info.vue?vue&type=script&lang=js"
import style0 from "./related-info.vue?vue&type=style&index=0&id=22bf61f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf61f0",
  null
  
)

export default component.exports